import { useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import { selectWebskin } from "reducers/auth";

import { selectClientLogo } from "reducers/virtualAssessments";
import { getJobBoardClientNameFromLocalStorage } from "helpers/jobBoardClientNameLocalStorage/getJobBoardClientNameFromLocalStorage";

import ClevryLogo from 'assets/apply.clevry/Logo2.png';
import SantanderLogo from 'assets/apply.clevry/santander-logo.png';


export const useLogo = (): string => {
    const selectedWebskin = useSelector(selectWebskin);
    const clientLogo = useSelector(selectClientLogo);
    
    return useMemo(() => {
        const logoOverride = getLogoOverride();

        if(logoOverride){
            return logoOverride;
        }

        if (clientLogo) {
            return clientLogo
          } else if (selectedWebskin && selectedWebskin.siteImages) {
            const webskinLogo = selectedWebskin.siteImages.find(
              (item: any) => item.code === 'SI_Logo'
            ).imageDownloadURI;
            return webskinLogo
          } else {
            return ClevryLogo;
          }
    }, [selectedWebskin, clientLogo])
}

const getLogoOverride = () => {
    const currentClient = getJobBoardClientNameFromLocalStorage();

    switch (currentClient) {
        case 'santandercib': 
        case 'staging-santandercib':
            return SantanderLogo;
        default: 
            return null;
    }
}